import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

export interface GoogleFontFamily {
  name: string
}

@Injectable({
  providedIn: 'root'
})
export class GoogleFontsService {
  private requestURL = `https://www.googleapis.com/webfonts/v1/webfonts?key=${environment.firebaseConfig.googleFontsApiKey}&sort=popularity`

  constructor(private http: HttpClient) {}

  public getGoogleFontsList$(): Observable<GoogleFontFamily[]> {
    return this.http.get<any>(`${this.requestURL}`).pipe(
      map((fontFamilyList) => {
        return fontFamilyList.items.map((fontFamily) => {
          return { name: fontFamily.family }
        })
      })
    )
  }
}
